import { ImmutableVector3 } from '@modugen/ui-toolkit'

export function wallIsXCartesian(wall: ShapeObject): boolean {
  return wall.shape.points[0].y === wall.shape.points[1].y
}

export function wallIsYCartesian(wall: ShapeObject): boolean {
  return wall.shape.points[0].x === wall.shape.points[1].x
}

export function wallIsCartesian(wall: ShapeObject): boolean {
  return wallIsXCartesian(wall) || wallIsYCartesian(wall)
}

export function lineIsXCartesian(start: ImmutableVector3, end: ImmutableVector3): boolean {
  return start.y === end.y
}

export function lineIsYCartesian(start: ImmutableVector3, end: ImmutableVector3): boolean {
  return start.x === end.x
}

export function lineIsCartesian(start: ImmutableVector3, end: ImmutableVector3): boolean {
  return lineIsXCartesian(start, end) || lineIsYCartesian(start, end)
}
